import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { BulkUpdateService } from 'src/app/_services/bulkupdate.service';
import { CategoryService } from 'src/app/_services/category.service';

@Component({
  selector: 'app-bulk-update-metadata',
  templateUrl: './bulk-update-metadata.component.html',
  styleUrls: ['./bulk-update-metadata.component.scss']
})
export class BulkUpdateMetadataComponent implements OnInit {

  button: string = "Save"
  formCategory: number
  searchCtrl: string;
  allCategories: any;
  allCategoryProperties: string[]
  targetAttributesDropDown = []
  targetAttributes: string[] = [];
  searchAttributesDropDown = []
  searchAttributes: string[] = [];
  searchQuery: any;
  targetQuery: any;
  bulkUpdateForm: FormGroup;
  selectedSearchAttribute: string
  operationCreated: boolean = false
  message: string

  constructor(
    private categoryService: CategoryService,
    private bulkUpdateService: BulkUpdateService
  ) { }

  ngOnInit() {
    this.getAllCategories()
    this.newForm()

  }

  newForm() {
    this.bulkUpdateForm = new FormGroup({
      name: new FormControl(''),
      categoryId: new FormControl(''),
      searchAttributeValues: new FormArray([this.initSearchValues()]),
      targetAttributeValues: new FormArray([this.initTargetValues()]),
    })
  }

  initSearchValues() {
    return new FormGroup({
      searchAttribute: new FormControl(''),
      searchValue: new FormControl('')
    });
  }

  initTargetValues() {
    return new FormGroup({
      targetAttribute: new FormControl(''),
      targetValue: new FormControl('')
    });
  }

  addSearchAttributeValue() {
    const control = <FormArray>this.bulkUpdateForm.get('searchAttributeValues');
    control.push(this.initSearchValues());
  }

  addTargetAttributeValue() {
    const control = <FormArray>this.bulkUpdateForm.get('targetAttributeValues');
    control.push(this.initTargetValues());
  }

  getSearchAttribute(form) {
    return form.controls.searchAttributeValues.controls;
  }

  deleteSearchAttributeValue(index: number) {
    this.searchFormArray.removeAt(index);
  }

  get searchFormArray() {
    return <FormArray>this.bulkUpdateForm.get("searchAttributeValues")
  }

  deleteTargetAttributeValue(index: number) {
    this.targetFormArray.removeAt(index);
  }

  get targetFormArray() {
    return <FormArray>this.bulkUpdateForm.get("targetAttributeValues")
  }


  getTargetAttribute(form) {
    return form.controls.targetAttributeValues.controls;
  }

  getAllCategories() {
    this.categoryService.getAll().subscribe(categories => {
      this.allCategories = categories
    })
  }

  getCategoryMetadata(categoryId) {
    this.allCategoryProperties = []
    for (let category of this.allCategories.results) {
      if (category.id == categoryId) {
        for (let metaData of category.meta_data_definition) {
          if (metaData.active) {
            for (let property of metaData.properties) {
              this.allCategoryProperties.push(property.name)
            }
          }
        }
      }
    }
    this.allCategoryProperties = this.allCategoryProperties.filter((elem, i, arr) => {
      if (arr.indexOf(elem) === i) {
        return elem
      }
    })
    this.targetAttributesDropDown = []
    this.searchAttributesDropDown = []
    this.allCategoryProperties.forEach((element, index) => {
      var obj = {}
      obj['value'] = element
      obj['disabled'] = false
      var searchObj = Object.assign({}, obj)
      var targetObj = Object.assign({}, obj)
      this.searchAttributesDropDown.push(searchObj)
      this.targetAttributesDropDown.push(targetObj)
    })
  }

  getSearchAttributes() {
    this.searchAttributes.forEach(attribute => {
      this.searchAttributesDropDown.forEach(element => {
        if (element.value == attribute) {
          element.disabled = true
        } else {
          element.disabled = false
        }
      })
    })
  }

  getTargetAttributes() {
    this.targetAttributes.forEach(targetAttribute => {
      this.targetAttributesDropDown.forEach(element => {
        if (element.value == targetAttribute) {
          element.disabled = true
        } else {
          element.disabled = false
        }
      })
    })
  }

  applyBulkUpdate() {
    var formData = Object.assign({}, this.bulkUpdateForm.value)
    var searchCriteria = {}
    var targetCriteria = {}
    formData.searchAttributeValues.forEach(element => {
      searchCriteria[element.searchAttribute] = element['searchValue']
    });
    formData.targetAttributeValues.forEach(element => {
      targetCriteria[element.targetAttribute] = element['targetValue']
    });
    var payload = {
      operationType: "update",
      categoryId: formData.categoryId,
      searchQuery: searchCriteria,
      updateValues: targetCriteria
    }
    //console.log("PAYLOAD", payload)
    this.bulkUpdateService.createBulkUpdate(payload).subscribe(data => {
      this.operationCreated = true
      this.message = "Operation ID: " + data['id'] + ". Bulk Update has been initiated."
      this.newForm()
      this.targetAttributes = []
      this.searchAttributes = []
      this.formCategory = null
    })
  }

  back() {
    this.operationCreated = false
  }
}
